import API from './config'

export const InstituitionAPI = {
    async listAllInstituitions() {

        try {

            const response = await API.get('/instituitions')

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async listActivesInstituitions() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/instituitions/actives', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error)

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async getInstituitionIdByInstituitionName(instituitionName) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/instituitions/getInstituitionIdByInstituitionName', { instituition_name: instituitionName }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error)

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async getInstituitionIdByInstituitionCod(instituitionCod) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/instituitions/getInstituitionIdByInstituitionCod', { instituition_cod: instituitionCod }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error)

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }

    },

    async updateInstituition(instituitionId, status) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/instituition', {
                id: instituitionId,
                status: status,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async save(instituition) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = instituition.id ?
                await API.put(`/instituitions/update`, instituition, config)
                :
                await API.post(`/instituitions/create`, instituition, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },
}